import {Divider} from "antd";

const SubBody = (props) => {
    return (
        <div>
            {props.children}
            <Divider/>
        </div>
    )
}

export default SubBody